











































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { OrganizationStep } from '@/classes/enums/OrganizationStep'
import OrganizationValidationRule from '@/classes/rules/OrganizationValidationRule'
import Organization from '@/classes/Organization'
import HIVETextField from '@/components/common/HIVETextField.vue'
import Product from '@/classes/Product'
import Subscription from '@/classes/Subscription'
import ProductLicense from '@/classes/ProductLicense'

@Component({
  components: {
    HIVETextField,
  },
})
export default class CreateUpdateSubscriptionForm extends Vue {
  @Prop(Boolean) public complete: boolean
  @Prop(Boolean) public isNewOrganization: boolean
  @Prop(Number) public step: number
  @Prop(Object) public organization: Organization

  private readonly organizationStep = OrganizationStep
  private readonly dateMinimumTimespan = 1

  private organizationValidationRule: OrganizationValidationRule = new OrganizationValidationRule()

  private licenseTypes: Array<object> = [
    { text: 'Trial', value: 100 },
    { text: 'Purchased', value: 200 },
    { text: 'Free', value: 300 },
  ]

  private get isComplete() {
    return this.complete
  }

  private get newOrganization() {
    return this.isNewOrganization
  }

  private get stepNumber() {
    return this.step
  }

  private get productList() {
    return this.$store.getters['uicontrols/getProducts']
  }

  private get productLicenses() {
    return this.$store.getters['organizations/getProductLicenses']
  }

  // function rather than computed prop due to necessity of providing a start date property for each element of an array of subscriptions
  private minDate(startDate: string) {
    if (startDate) {
      const min = new Date(Date.parse(startDate))
      min.setDate(min.getDate() + this.dateMinimumTimespan)
      return min.toISOString()
    }
  }

  /** addProductLicenses happens during the creation part of the form */
  private addProductLicenses() {
    this.organization.productLicenses.push(new ProductLicense())
  }

  /** updateProduceLicenses happens during the edit part of thje form */
  private updateProductLicenses() {
    this.productLicenses.push(new ProductLicense())
  }
}
